export const SUPPORTED_INTERVIEW_LANGUAGES = [
  'en',
  'es',
  'fr',
  'de',
  'pt',
  'it',
  'nl',
  'sv',
  'no',
  'da',
  'fi',
  'pl',
  'ar',
  'zh',
  'ja',
  'ko'
] as const;

export type SupportedInterviewLanguage = (typeof SUPPORTED_INTERVIEW_LANGUAGES)[number];

export const SCORING_RECOMMENDATION = ['shortlist', 'reject', 'review'] as const;
export type ScoringRecommendation = (typeof SCORING_RECOMMENDATION)[number];
